import { initOembedContainers } from 'Shared/remote_embed';
import { bindLightboxImageClicks } from 'Shared/lightbox_image_clicks';

initOembedContainers();
// Story bodies render through the Answers post grammar, so their images
// carry the same data-lightbox-src markup.
bindLightboxImageClicks();

onDomReady(() => {
   document.querySelectorAll('.js-add-image-modal').forEach(el => {
      el.addEventListener('click', ev => {
         ev.preventDefault();
         ev.stopPropagation();
         const imgUrl = el.dataset.modalimg;
         void import('Shared/modal').then(({ Modal }) => {
            Modal.openModalImg(imgUrl);
         });
      });
   });

   document.querySelectorAll('.js-thumbnail-image').forEach(thumb => {
      thumb.addEventListener('mouseenter', () => {
         const imageid = thumb.dataset.imageid;
         document.querySelectorAll('.js-main-image').forEach(main => {
            main.style.display = 'none';
         });
         document.getElementById('image-' + imageid).style.display = 'block';
      });
   });
});
